import React from "react";
import { Route } from "react-router-dom";
import PrivateRoute from "src/routes/PrivateRoute";
import { SurveyDetailsPage, SurveysPage } from "../pages";

export const routes = (
  <>
    <Route
      path="/surveys"
      element={
        <PrivateRoute>
          <SurveysPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/survey-responses/:surveyId"
      element={
        <PrivateRoute>
          <SurveyDetailsPage />
        </PrivateRoute>
      }
    />
  </>
);